import React from 'react';
import { Routes, Route, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import Collages from './Collages';
import AddCollage from './AddCollage';
import ViewColleges from './ViewColleges';
import EditCollege from './EditCollege';

const ProtectedRoute = ({ element, permission, fallbackPath = '/' }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!permission) {
      toast.warning("You don't have permission to access this page.");
      navigate("/dashboard/collage", { replace: true });
    }
  }, [permission, navigate, fallbackPath]);

  return permission ? element : null;
};

const MainCollage = () => {
  const User = JSON.parse(localStorage.getItem("User") || "{}");
  const Permission = User?.userRole?.permissions?.master || {}; // Only using 'master' permissions

  return (
    <div className='bg-gray-100 text-gray-900 px-4 dark:bg-gray-900 dark:text-white'>
      <Routes>
        <Route path='/' element={<Collages />} />

        <Route 
          path='/add-collage' 
          element={<ProtectedRoute element={<AddCollage />} permission={Permission.create} fallbackPath="/" />}
        />

        <Route 
          path='/view-collage' 
          element={<ProtectedRoute element={<ViewColleges />} permission={Permission.read} fallbackPath="/" />}
        />

        <Route 
          path='/edit-collage' 
          element={<ProtectedRoute element={<EditCollege />} permission={Permission.update} fallbackPath="/" />}
        />
      </Routes>
    </div>
  );
};
export default MainCollage;